import { rd } from '@passionware/monads';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveWorkspaceSlugForLinks } from './resolveWorkspaceSlugForLinks';
import { appRouting } from 'v5/core/routing/appRouting';
import { myServices } from 'v5/services/services.connected.app';

export function useWorkspaceRouting() {
  const scopeRd = myServices.appScopeService.useResolvedAppScope();
  const scopeRdStable = rd.useLastWithPlaceholder(scopeRd);
  const scope = rd.tryGet(scopeRdStable);
  const { pathname } = useLocation();
  const workspacesRd = myServices.enterpriseService.useWorkspaces(
    rd.tryMap(scopeRdStable, s => s.organizationId)
  );
  const workspaces = rd.tryGet(workspacesRd);

  const workspaceSlug = useMemo(() => {
    if (!scope) {
      return ':workspaceId';
    }
    return resolveWorkspaceSlugForLinks(scope, pathname, workspaces);
  }, [scope, pathname, workspaces]);

  return useMemo(
    () =>
      appRouting
        .org(scope?.organizationId ?? ':app_id')
        .workspace(workspaceSlug),
    [scope?.organizationId, workspaceSlug]
  );
}

export function useTeamRouting() {
  const scopeRd = myServices.appScopeService.useResolvedAppScope();
  const scopeRdStable = rd.useLastWithPlaceholder(scopeRd);
  const scope = rd.tryGet(scopeRdStable);
  const { pathname } = useLocation();
  const workspacesRd = myServices.enterpriseService.useWorkspaces(
    rd.tryMap(scopeRdStable, s => s.organizationId)
  );
  const workspaces = rd.tryGet(workspacesRd);

  const workspaceSlug = useMemo(() => {
    if (!scope) {
      return ':workspaceId';
    }
    return resolveWorkspaceSlugForLinks(scope, pathname, workspaces);
  }, [scope, pathname, workspaces]);
  const teamSlug = scope?.level === 'team' ? scope.teamSlug : ':teamId';

  return useMemo(
    () =>
      appRouting
        .org(scope?.organizationId ?? ':app_id')
        .workspace(workspaceSlug)
        .team(teamSlug),
    [scope?.organizationId, workspaceSlug, teamSlug]
  );
}
